document.addEventListener("DOMContentLoaded", function () {
    //*Apply width and height values to each logo 
    const images = document.querySelectorAll(".js-brand-item img");

    images.forEach(img => {
        img.addEventListener('load', function () {
            img.setAttribute("width", img.naturalWidth);
            img.setAttribute("height", img.naturalHeight);
        });

        // If the image is already cached, the load event might not trigger,
        // so we check if it's already loaded
        if (img.complete) {
            img.setAttribute("width", img.naturalWidth);
            img.setAttribute("height", img.naturalHeight);
        }
    });
});